var map = {
	"./comfirm0.png": "CER1",
	"./comfirmen.png": "B4Ad",
	"./comfirmzh-tw.png": "g/MG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bst3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hongbao/img ^\.\/comfirm.*\.png$
// module id = bst3
// module chunks = 1